import { render, staticRenderFns } from "./OpsLinks.vue?vue&type=template&id=c4f2f408&scoped=true"
import script from "./OpsLinks.vue?vue&type=script&lang=ts"
export * from "./OpsLinks.vue?vue&type=script&lang=ts"
import style0 from "./OpsLinks.vue?vue&type=style&index=0&id=c4f2f408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f2f408",
  null
  
)

export default component.exports